import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  transaksiMasukTable,
  extraTransaksiMasukRow,
} from "./transaksiMasukTable";
import { transaksiMasukDetailTable } from "./transaksiMasukDetailTable";
import { transaksiMasukFilter } from "./transaksiMasukFilterData";

// API
import {
  deleteTransaksiMasuk,
  exportSpesifikTransaksiMasuk,
  getDataTransMasuk,
  getFilteredTransaksiMasuk,
  getNomorTransaksiMasuk,
  importCSVTransaksiMasuk,
  insertNewTransaksiMasuk,
  updateTransaksiMasuk,
} from "./api/transaksiMasukAPI";
import { getDropdownTahunAnggaranPemasukan } from "views/admin/masterData/anggaranPemasukan/api/anggaranPemasukanAPI";

// Component
import CardTableNoAdd from "components/Cards/CardTableNoAdd";
import ConfirmModal from "components/Modal/ConfirmModal";
import FormCustom from "components/Forms/FormCustom";

import toast, { Toaster } from "react-hot-toast";
import {
  transaksiMasukFormData,
  transaksiMasukPindahAnggaranFormData,
} from "./transaksiMasukFormData";
import jsPDF from "jspdf";
import ShowDetailModal from "components/Modal/ShowDetailModal";
import UploadFileModal from "components/Modal/UploadFileModal";
import { getDropdownPelanggan } from "views/admin/masterData/pelanggan/api/pelangganAPI";
import { getDropdownKodeAkunOnlyKas } from "views/admin/masterData/kodeAkun/api/kodeAkunAPI";
import { getDropdownUnitUsaha } from "views/admin/masterData/unitUsaha/api/unitUsahaAPI";
import UploadMultipleFileModal from "components/Modal/UploadMultipleFileModal";
import ExcelExport from "components/Exports/ExcelExport";
import { getDropdownAnggaranPemasukan } from "views/admin/masterData/anggaranPemasukan/api/anggaranPemasukanAPI";

export default function TransaksiMasuk() {
  const history = useHistory();

  const [dataTable, setDataTable] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);

  const [active, setActive] = useState(false);

  // const [formData, setFormData] = useState(null);

  // const [formDataArr, setFormDataArr] = useState([]);

  // Select-Option Data
  const [dropdownTahunAnggaran, setDropdownTahunAnggaran] = useState([]);
  const [dropdownPelanggan, setDropdownPelanggan] = useState([]);
  const [dropdownOnlyKas, setDropdownOnlyKas] = useState([]);
  const [dropdownUnitUsaha, setDropdownUnitUsaha] = useState([]);
  const [dropdownAnggaranPemasukan, setDropdownAnggaranPemasukan] = useState(
    []
  );

  const [noTransMasuk, setNoTransMasuk] = useState("P-NNNN-NNN");

  // Type Search
  const [typeSearch, setTypeSearch] = useState("");

  const [currentData, setCurrentData] = useState([]);
  const [typeSearchDetail, setTypeSearchDetail] = useState("");

  // Filter Data
  const [filterData, setFilterData] = useState(null);

  // Filter Data Arr
  const [filterDataArr, setFilterDataArr] = useState(null);

  const [isLoading, setIsLoading] = useState(false);

  // State for Table Detail Transaksi Masuk
  const [showDetailTransaksi, setShowDetailTransaksi] = useState(false);
  const [detailTransaksi, setDetailTransaksi] = useState(false);

  const [result, setResult] = useState(null);
  const [deleteResult, setDeleteResult] = useState(null);
  const [errors, setErrors] = useState(null);

  const [deletePopUp, setDeletePopUp] = useState([{ show: false, id: null }]);
  const [showDetailPopUp, setShowDetailPopUp] = useState([
    {
      show: false,
      id: null,
      data: null,
    },
  ]);

  const [showUploadBuktiTransaksiPopUp, setShowUploadBuktiTransaksiPopUp] =
    useState([
      {
        show: false,
        id: null,
        data: null,
      },
    ]);

  const [showUploadCSVPopUp, setShowUploadCSVPopUp] = useState([
    {
      show: false,
      id: null,
      data: null,
    },
  ]);
  const [showPindahAnggaran, setShowPindahAnggaran] = useState([
    {
      show: false,
      id: null,
      data: null,
    },
  ]);

  // State for Upload Bukti Transaksi Masuk
  const [uploadedFile, setUploadedFile] = useState(null);
  const [uploadedCSVFile, setUploadedCSVFile] = useState(null);

  // State For Input New Transaksi Masuk
  const [addForm, setAddForm] = useState(false);
  const [formData, setFormData] = useState(null);
  const [formDataArr, setFormDataArr] = useState([]);

  // State for Pindah Anggaran
  const [formDataPindahAnggaran, setFormDataPindahAnggaran] = useState(null);
  const [formDataArrPindahAnggaran, setFormDataArrPindahAnggaran] = useState(
    []
  );

  // Extra Row Params
  const [totalTarget, setTotalTarget] = useState(0);
  const [totalRealisasi, setTotalRealisasi] = useState(0);

  const [dataExport, setDataExport] = useState([]);

  // Component is Active?
  useEffect(() => {
    setActive(true);
    return () => {
      setActive(false);
    };
  }, []);

  // Loading
  useEffect(() => {
    if (isLoading === true) {
      toast.loading("Data Diproses...");
    }
  }, [isLoading]);

  useEffect(() => {
    exportSpesifikTransaksiMasuk()
      .then((res) => {
        setDataExport(res.data.data);
      })
      .catch((err) => {
        setErrors(err);
      });
  }, []);

  // Load Data Table
  useEffect(() => {
    if (active === true) {
      setIsLoading(true);
      getDataTransMasuk()
        .then((response) => {
          setDataTable(response.data.data);
          setTotalRealisasi(response.data.total_realisasi);
          setTotalTarget(response.data.total_target);
        })
        .catch((error) => console.error(`Error: ${error}`))
        .finally(setIsLoading(false));
    }

    return () => {
      // setFormData(null);
    };
  }, [active]);

  // Select-Option Data
  // Load Dropdown Tahun Anggaran Pemasukan
  useEffect(() => {
    setIsLoading(true);

    getDropdownTahunAnggaranPemasukan()
      .then((response) => {
        setDropdownTahunAnggaran(response.data.data);
      })
      .catch((err) => setErrors(err))
      .finally(setIsLoading(false));

    return () => {
      setDropdownTahunAnggaran([]);
    };
  }, [active]);

  // Load Dropdown Anggaran Pemasukan
  useEffect(() => {
    setIsLoading(true);

    getDropdownAnggaranPemasukan()
      .then((response) => {
        setDropdownAnggaranPemasukan(response.data.data);
      })
      .catch((err) => setErrors(err))
      .finally(setIsLoading(false));

    return () => {
      setDropdownAnggaranPemasukan([]);
    };
  }, [active]);

  // Load Dropdown Pelanggan
  useEffect(() => {
    setIsLoading(true);

    getDropdownPelanggan()
      .then((response) => {
        setDropdownPelanggan(response.data.data);
      })
      .catch((err) => setErrors(err))
      .finally(setIsLoading(false));

    return () => {
      setDropdownPelanggan([]);
    };
  }, [active]);

  // Load Dropdown Kode Akun Only Kas
  useEffect(() => {
    setIsLoading(true);

    getDropdownKodeAkunOnlyKas()
      .then((response) => {
        setDropdownOnlyKas(response.data.data);
      })
      .catch((err) => setErrors(err))
      .finally(setIsLoading(false));

    return () => {
      setDropdownOnlyKas([]);
    };
  }, [active]);

  // Load Dropdown Unit Usaha
  useEffect(() => {
    setIsLoading(true);

    getDropdownUnitUsaha()
      .then((response) => {
        setDropdownUnitUsaha(response.data.data);
      })
      .catch((err) => setErrors(err))
      .finally(setIsLoading(false));

    return () => {
      setDropdownUnitUsaha([]);
    };
  }, [active]);

  // Load Nomor Transaksi Masuk
  useEffect(() => {
    setIsLoading(true);

    getNomorTransaksiMasuk()
      .then((response) => {
        setNoTransMasuk(response.data.data.nomor_transaksi_masuk);
      })
      .catch((err) => setErrors(err))
      .finally(setIsLoading(false));

    return () => {
      setNoTransMasuk("P-NNNN-NNN");
    };
  }, [active]);

  // Load Filter Data Arr
  useEffect(() => {
    setFilterDataArr(
      transaksiMasukFilter(dropdownTahunAnggaran, dropdownUnitUsaha)
    );

    return () => {
      setFilterDataArr([]);
    };
  }, [dropdownTahunAnggaran, dropdownUnitUsaha]);

  // Set Inputed Data Filter to State filterData
  const setDataFilter = (key, value) => {
    return setFilterData({ ...filterData, [key]: value });
  };

  // Handle when User Click Button Filter Data
  const handleFilter = () => {
    if (filterData !== null) {
      getFilteredTransaksiMasuk(filterData)
        .then((response) => {
          setDataTable(response.data.data);
          setTotalRealisasi(response.data.total_realisasi);
          setTotalTarget(response.data.total_target);
        })
        .catch((error) => console.error(`Error: ${error}`))
        .finally(setIsLoading(false));
      setPageNumber(0);
    }
  };

  // Handle when User Click Button Reset Filter Data
  const handleResetFilter = () => {
    setFilterData(null);
    getDataTransMasuk()
      .then((response) => {
        setDataTable(response.data.data);
        setTotalRealisasi(response.data.total_realisasi);
        setTotalTarget(response.data.total_target);
      })
      .catch((error) => console.error(`Error: ${error}`))
      .finally(setIsLoading(false));
    setPageNumber(0);
  };

  // Clear Form Data When First Time Load Component
  // useEffect(() => {
  //   setFormData(null);
  // })

  // Handle Search
  const handleSearch = (e) => {
    setTypeSearch(e.target.value);
  };

  const handleSearchDetail = (e) => {
    setTypeSearchDetail(e.target.value);
  };

  // Handle when Searching Changes
  useEffect(() => {
    const getDataSearchResult = () => {
      getDataTransMasuk(typeSearch)
        .then((response) => {
          setDataTable(response.data.data);
          setTotalRealisasi(response.data.total_realisasi);
          setTotalTarget(response.data.total_target);
        })
        .catch((error) => console.error(`Error: ${error}`))
        .finally(setIsLoading(false));
      setPageNumber(0);
    };

    const getData = () => {
      getDataTransMasuk()
        .then((response) => {
          setDataTable(response.data.data);
          setTotalRealisasi(response.data.total_realisasi);
          setTotalTarget(response.data.total_target);
        })
        .catch((error) => console.error(`Error: ${error}`))
        .finally(setIsLoading(false));
      setPageNumber(0);
    };

    let timer = setTimeout(() => {
      if (typeSearch) {
        getDataSearchResult();
      } else {
        getData();
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [typeSearch]);

  // Handle when searching detail changes
  useEffect(() => {
    setPageNumber(0);

    const getDataSearchDetailResult = () => {
      const detailDataTransaksiMasuk = currentData.detail_transaksi_masuk;

      const filteredDataDetailTransaksiMasuk = detailDataTransaksiMasuk.filter(
        (obj) => {
          return (
            (obj.nomor_transaksi_masuk &&
              obj.nomor_transaksi_masuk
                .toLowerCase()
                .includes(typeSearchDetail.toLowerCase())) ||
            (obj.keterangan_transaksi_masuk &&
              obj.keterangan_transaksi_masuk
                .toLowerCase()
                .includes(typeSearchDetail.toLowerCase())) ||
            (obj.nama_pelanggan &&
              obj.nama_pelanggan
                .toLowerCase()
                .includes(typeSearchDetail.toLowerCase())) ||
            (obj.nama_akun_via_bayar_masuk &&
              obj.nama_akun_via_bayar_masuk
                .toLowerCase()
                .includes(typeSearchDetail.toLowerCase())) ||
            (obj.tanggal_transaksi_masuk &&
              obj.tanggal_transaksi_masuk
                .toLowerCase()
                .includes(typeSearchDetail.toLowerCase()))
          );
        }
      );

      Array.isArray(filteredDataDetailTransaksiMasuk) &&
        filteredDataDetailTransaksiMasuk.sort((a, b) => {
          let da = new Date(a.tanggal_transaksi_masuk);
          let db = new Date(b.tanggal_transaksi_masuk);
          return db - da;
        });
      setDetailTransaksi(filteredDataDetailTransaksiMasuk);
    };

    const getDataDetail = () => {
      const filteredDataDetailTransaksiMasuk =
        currentData.detail_transaksi_masuk;

      Array.isArray(filteredDataDetailTransaksiMasuk) &&
        filteredDataDetailTransaksiMasuk.sort((a, b) => {
          let da = new Date(a.tanggal_transaksi_masuk);
          let db = new Date(b.tanggal_transaksi_masuk);
          return db - da;
        });

      setDetailTransaksi(filteredDataDetailTransaksiMasuk);
    };

    let timer = setTimeout(() => {
      if (typeSearchDetail) {
        getDataSearchDetailResult();
      } else {
        getDataDetail();
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [currentData, typeSearchDetail]);

  // Handle When Page Change
  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  // Handle When User want to see detail Transaksi Masuk
  const handleGetDetail = (rowData) => {
    // Lihat Detail Transaksi
    setActive(false);
    setShowDetailTransaksi(true);
    setPageNumber(0);

    setCurrentData(rowData);
    const detailDataTransaksiMasuk = rowData.detail_transaksi_masuk;

    detailDataTransaksiMasuk.sort((a, b) => {
      let da = new Date(a.tanggal_transaksi_masuk);
      let db = new Date(b.tanggal_transaksi_masuk);
      return db - da;
    });

    // Tambahkan Data Detail Transaksi
    setDetailTransaksi(detailDataTransaksiMasuk);
  };

  // Handle When User Click Cancel Button in Detail Transaksi Masuk
  const handleCancelButton = () => {
    setShowDetailTransaksi(false);
    // setPageNumber(0);
    setAddForm(false);
    handleClosePindahAnggaran();
  };

  // Handle when User Click Delete Button
  const handleDelete = (rowData) => {
    // console.log(
    //   detailTransaksi.filter((transaksi) => {
    //     return transaksi.id_transaksi_masuk !== "ITM2205180001";
    //   })
    // );

    setDeletePopUp({
      show: true,
      id: rowData.id_transaksi_masuk,
    });
  };

  // Handle When User Confirm to Delete Data
  const handleDeleteTrue = () => {
    if (deletePopUp.show && deletePopUp.id) {
      setIsLoading(true);

      deleteTransaksiMasuk(deletePopUp.id)
        .then((response) => {
          setDetailTransaksi(
            detailTransaksi.filter((dT) => {
              return dT.id_transaksi_masuk !== deletePopUp.id;
            })
          );
          setDeleteResult(response);
        })
        .catch((err) => setErrors(err))
        .finally(endSubmitProcess());
    }
  };

  // Handle When User Deny to Confirm Delete Data
  const handleDeleteFalse = () => {
    setDeletePopUp({
      show: false,
      id: null,
    });
  };

  // Handle when user click show detail button
  function handleShowDetail(rowData) {
    setShowDetailPopUp({
      show: true,
      id: rowData.id_transaksi_masuk,
      data: rowData,
    });
  }

  // Handle when user want to close show detail modal
  const handleCloseShowDetail = () => {
    setShowDetailPopUp({
      show: false,
      id: null,
      data: null,
    });
  };

  // Handle when User click Upload Bukti Button
  const handleUploadBuktiTransaksi = (rowData) => {
    setShowUploadBuktiTransaksiPopUp({
      show: true,
      id: rowData.id_transaksi_masuk,
      data: null,
    });
  };

  // Handle when User click close upload bukti button
  const handleCloseUploadBuktiTransaksi = () => {
    setShowUploadBuktiTransaksiPopUp({
      show: false,
      id: null,
      data: null,
    });
  };

  // Handle when User Click Import CSV
  const handleUploadCSV = () => {
    setShowUploadCSVPopUp({
      show: true,
      id: null,
      data: null,
    });
  };

  // Handle when User click close import CSV
  const handleCloseUploadCSV = () => {
    setShowUploadCSVPopUp({
      show: false,
      id: null,
      data: null,
    });
  };

  // Handle when User Click Pindah Anggaran
  const handlePindahAnggaran = (rowData) => {
    setShowPindahAnggaran({
      show: true,
      id: rowData.id_transaksi_masuk,
      data: rowData,
    });
  };

  // Handle when User Click Close Pindah Anggaran
  const handleClosePindahAnggaran = () => {
    setShowPindahAnggaran({
      show: false,
      id: null,
      data: null,
    });
  };

  // Handle End Submit Process
  const endSubmitProcess = () => {
    setDeletePopUp({ show: false });
    setIsLoading(false);
  };

  // Check If Request Failed
  useEffect(() => {
    if (errors !== null) {
      toast.error(errors.message);
    }
  });

  // Check if Request Success
  useEffect(() => {
    if (result !== null) {
      if (result.data.success === true) {
        toast.success(result.data.message);
        setActive(true);
        setFormData(null);
        history.push("transaction/transaksiMasuk");
        setShowDetailTransaksi(true);
      } else {
        let numericArray = [];
        for (let err in result.data.errors) {
          numericArray.push(result.data.errors[err]);
        }

        if (numericArray.length > 0) {
          toast.error(numericArray[0]);
        }
      }
      setResult(null);
      toast.dismiss();
    }
    return () => {
      setResult(null);
    };
  }, [history, result]);

  // Handle Cetak Kwitansi
  const handleCetakKwitansi = (rowData) => {
    const doc = new jsPDF();

    doc.setFontSize(12);
    doc.text("Jl. Subang Bandung KM 12 RT 24", 12, 20);
    doc.text("RW 4 Ds. Tambak Mekar Kec.", 12, 30);
    doc.text("Jalancagak.", 12, 40);

    doc.text(`No: ${rowData.nomor_transaksi_masuk}`, 160, 20);
    doc.setFontSize(16);
    doc.text("Bukti Kas Masuk", 105, 60, null, null, "center");
    doc.setFontSize(14);
    doc.text("Diterima anggaran untuk", 40, 70);
    doc.text(`: ${rowData.nama_anggaran_pemasukan}`, 120, 70);
    doc.text("Jumlah", 40, 80);
    doc.text(`: ${rowData.jumlah_transaksi_masuk}`, 120, 80);
    doc.text("Keterangan Transaksi :", 12, 93);
    doc.setFontSize(12);
    doc.text(`${rowData.keterangan_transaksi_masuk}`, 12, 103);
    doc.setFontSize(12);
    doc.text(`Subang, ${rowData.created_at}`, 200, 120, null, null, "right");
    doc.text("Yang Menerima", 200, 130, null, null, "right");
    doc.text(`${rowData.created_by}`, 200, 160, null, null, "right");

    doc.save(`bukti-kwitansi-${rowData.nomor_transaksi_masuk}.pdf`);
  };

  // Check if Delete Request Success
  useEffect(() => {
    if (deleteResult !== null) {
      if (deleteResult.data.success === true) {
        toast.success(deleteResult.data.message);
        setActive(true);
        setShowDetailTransaksi(true);
      } else {
        let numericArray = [];
        for (let err in deleteResult.data.errors) {
          numericArray.push(deleteResult.data.errors[err]);
        }

        if (numericArray.length > 0) {
          toast.error(numericArray[0]);
        }
      }
      setDeleteResult(null);
    }
    return () => {
      setDeleteResult(null);
    };
  }, [deleteResult]);

  // Clear Form Data When First Time Load Component
  useEffect(() => {
    setFormData(null);
  }, []);

  // Load Form Data Arr
  useEffect(() => {
    setFormDataArr(
      transaksiMasukFormData(dropdownPelanggan, noTransMasuk, dropdownOnlyKas)
    );

    return () => {
      setFormDataArr([]);
    };
  }, [dropdownPelanggan, noTransMasuk, dropdownOnlyKas]);

  // Load Form Data Arr Pindah Anggaran
  useEffect(() => {
    setFormDataArrPindahAnggaran(
      transaksiMasukPindahAnggaranFormData(dropdownAnggaranPemasukan)
    );

    return () => {
      setFormDataArrPindahAnggaran([]);
    };
  }, [dropdownAnggaranPemasukan]);

  // Handle when User Click Add Button
  function handleInsert(rowData) {
    setActive(false);
    setFormData({ id_anggaran_pemasukan: rowData.id_anggaran_pemasukan });
    setAddForm(true);
  }

  // Handle when User Submit New Data
  const handleInsertSubmit = (e) => {
    e.preventDefault();

    setIsLoading(true);
    const data = new FormData();

    if (formData !== null) {
      Object.keys(formData).forEach(
        (key) =>
          key !== "bukti_transaksi_masuk" && data.append(key, formData[key])
      );

      if (formData?.bukti_transaksi_masuk) {
        if (formData?.bukti_transaksi_masuk.length > 0) {
          for (const bukti of formData.bukti_transaksi_masuk) {
            data.append("bukti_transaksi_masuk[]", bukti);
          }
        }
      }
    }

    insertNewTransaksiMasuk(data)
      .then((response) => setResult(response))
      .catch((err) => setErrors(err))
      .finally(() => endSubmitProcess());
  };

  // Handle Edit (Upload Bukti Transaksi)
  const handleSubmitUploadBuktiTransaksi = (e) => {
    e.preventDefault();

    setIsLoading(true);

    const formData = new FormData();

    if (uploadedFile !== null) {
      if (uploadedFile["bukti_transaksi_masuk"]) {
        if (uploadedFile["bukti_transaksi_masuk"].length > 0) {
          for (const bukti of uploadedFile["bukti_transaksi_masuk"]) {
            formData.append("bukti_transaksi_masuk[]", bukti);
          }
        }
      }
    }
    // formData.append(
    //   "bukti_transaksi_masuk[]",
    //   uploadedFile["bukti_transaksi_masuk"]
    // );
    // if (uploadedFile !== null) {
    //   Object.keys(uploadedFile).forEach((key) =>
    //     formData.append(key, uploadedFile[key])
    //   );
    // }

    // console.log(uploadedFile["bukti_transaksi_masuk"]);
    // console.log(formData);

    // Display the key/value pairs
    // for (var pair of fileData.entries()) {
    //   console.log(pair[0] + ", " + pair[1]);
    // }

    updateTransaksiMasuk(showUploadBuktiTransaksiPopUp.id, formData)
      .then((response) => {
        setResult(response);
      })
      .catch((err) => setErrors(err))
      .finally(() => endSubmitProcess());
  };

  // Handle Submit Import CSV
  const handleSubmitUploadCSV = (e) => {
    e.preventDefault();

    setIsLoading(true);

    const formData = new FormData();

    if (uploadedCSVFile !== null) {
      formData.append(
        "csv_transaksi_masuk",
        uploadedCSVFile["csv_transaksi_masuk"]
      );
    }

    // console.log(uploadedCSVFile);

    importCSVTransaksiMasuk(formData)
      .then((response) => {
        setResult(response);
      })
      .catch((err) => setErrors(err))
      .finally(() => endSubmitProcess());
  };

  const handleSubmitPindahAnggaran = (e) => {
    e.preventDefault();

    const formData = new FormData();

    if (!formDataPindahAnggaran?.id_anggaran_pemasukan) {
      toast.error("Silahkan Pilih Anggaran Terlebih Dahulu");
      return;
    }

    setIsLoading(true);

    formData.append(
      "id_anggaran_pemasukan",
      formDataPindahAnggaran.id_anggaran_pemasukan
    );

    handleClosePindahAnggaran();

    updateTransaksiMasuk(showPindahAnggaran.id, formData)
      .then((response) => {
        if (response !== null) {
          if (response.data.success === true) {
            let updatedDetailTransaksi = [];

            if (
              currentData.id_anggaran_pemasukan !==
              formDataPindahAnggaran.id_anggaran_pemasukan
            ) {
              updatedDetailTransaksi = detailTransaksi.filter((obj) => {
                return obj.id_transaksi_masuk !== showPindahAnggaran.id;
              });
            } else {
              updatedDetailTransaksi = detailTransaksi;
            }

            const updatedCurrentData = currentData;

            updatedCurrentData.detail_transaksi_masuk = updatedDetailTransaksi;

            setDetailTransaksi(updatedDetailTransaksi);
            setCurrentData(updatedCurrentData);
            toast.success(response.data.message);
            setActive(true);
            setFormData(null);
            setShowDetailTransaksi(true);
          } else {
            let numericArray = [];
            for (let err in response.data.errors) {
              numericArray.push(response.data.errors[err]);
            }

            if (numericArray.length > 0) {
              toast.error(numericArray[0]);
            }
          }
          toast.dismiss();
        }
      })
      .catch((err) => setErrors(err))
      .finally(() => endSubmitProcess());
  };

  const setData = (key, value) => {
    return setFormData({ ...formData, [key]: value });
  };

  const setFile = (key, value) => {
    return setUploadedFile({ [key]: value });
  };

  const setCSVFile = (key, value) => {
    return setUploadedCSVFile({ [key]: value });
  };

  const setDataPindahAnggaran = (key, value) => {
    return setFormDataPindahAnggaran({
      ...formDataPindahAnggaran,
      [key]: value,
    });
  };

  if (addForm === true)
    return (
      <div>
        <div className="flex flex-wrap mt-4">
          <div className="w-full mb-12 px-4">
            <Toaster />
            <FormCustom
              title={"Tambah Data"}
              formDataArr={formDataArr}
              handleSubmit={handleInsertSubmit}
              handleCancelButton={handleCancelButton}
              setData={setData}
              editFormValue={null}
              // getData = {getData}
            />
          </div>
        </div>
      </div>
    );

  if (showDetailTransaksi === true)
    return (
      <div>
        <div className="flex flex-wrap mt-4">
          <div className="w-full mb-12 px-4">
            {deletePopUp.show && (
              <div>
                <ConfirmModal
                  handleIfTrue={(e) => handleDeleteTrue()}
                  handleIfFalse={(e) => handleDeleteFalse()}
                />
              </div>
            )}
            {showDetailPopUp.show && (
              <div>
                <ShowDetailModal
                  handleClose={(e) => handleCloseShowDetail()}
                  detailData={showDetailPopUp.data}
                />
              </div>
            )}
            {showUploadBuktiTransaksiPopUp.show && (
              <div>
                <UploadMultipleFileModal
                  handleSubmit={handleSubmitUploadBuktiTransaksi}
                  handleClose={(e) => handleCloseUploadBuktiTransaksi()}
                  setFile={setFile}
                  name="bukti_transaksi_masuk"
                  fileExtensions="jpg, png, jpeg"
                />
              </div>
            )}
            {showPindahAnggaran.show && (
              <div>
                <FormCustom
                  title={`Pindah Anggaran (Nomor Transaksi: ${showPindahAnggaran.data.nomor_transaksi_masuk})`}
                  formDataArr={formDataArrPindahAnggaran}
                  handleSubmit={handleSubmitPindahAnggaran}
                  handleCancelButton={handleClosePindahAnggaran}
                  setData={setDataPindahAnggaran}
                  editFormValue={null}
                  // getData = {getData}
                />
              </div>
            )}
            <Toaster />
            <CardTableNoAdd
              tableTitle="Tabel Detail Transaksi Penerimaan"
              cols={transaksiMasukDetailTable(
                handleUploadBuktiTransaksi,
                handleCetakKwitansi,
                handlePindahAnggaran,
                handleDelete,
                handleShowDetail
              )}
              handleSearch={handleSearchDetail}
              data={detailTransaksi}
              handleCancelButton={handleCancelButton}
              pageNumber={pageNumber}
              changePage={changePage}
              exportCSVButton={true}
            />
          </div>
        </div>
      </div>
    );

  return (
    <div>
      <div className="flex flex-wrap mt-4">
        <div className="w-full mb-12 px-4">
          {showUploadCSVPopUp.show && (
            <div>
              <UploadFileModal
                handleSubmit={handleSubmitUploadCSV}
                handleClose={(e) => handleCloseUploadCSV()}
                setFile={setCSVFile}
                name="csv_transaksi_masuk"
                fileExtensions="csv"
              />
            </div>
          )}
          {/* {deletePopUp.show && <div><ConfirmModal handleIfTrue={(e) => handleDeleteTrue()} handleIfFalse={(e) => handleDeleteFalse()} /></div>} */}
          <Toaster />

          <CardTableNoAdd
            tableTitle="Tabel Transaksi Penerimaan"
            cols={transaksiMasukTable(handleGetDetail, handleInsert)}
            data={dataTable}
            handleSearch={handleSearch}
            pageNumber={pageNumber}
            changePage={changePage}
            handleFilter={(e) => handleFilter()}
            handleResetFilter={(e) => handleResetFilter()}
            filterDataArr={filterDataArr}
            setDataFilter={setDataFilter}
            extraRow={extraTransaksiMasukRow(totalRealisasi, totalTarget)}
            importCSVButton={true}
            handleUploadCSV={handleUploadCSV}
          />

          {dataExport.length > 0 && (
            <div className="py-2 px-4 hidden">
              <ExcelExport
                excelData={dataExport}
                fileName={"Transaksi_masuk"}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
